export type PlanKey = "interact_pro"; // TODO: add more plans as needed.

export interface PlanMeta {
  key: PlanKey | null;
  name: string;
  // Must have at least one price, or null for free (Hobbyist) plan.
  prices: PriceMeta[] | null;
  features: { name: string; description?: string }[];
}

export interface PriceMeta {
  key: string;
  schedule: "monthly" | "annual";
  // price etc. from lookup by key
  needsFeatureSwitch?: boolean; // needs useFeatureSwitch("new-billing")
}

export const plansMeta: PlanMeta[] = [
  {
    key: null,
    name: "Hobbyist",
    prices: null,
    features: [
      { name: "Free While Active", description: "Active means used within the last two months." },
      { name: "200 MB Cloud Storage" },
      { name: "Up to 3 Modules", description: "Downgrading will not remove any existing modules." },
      { name: "Preview Only" },
      { name: "Community Support" },
    ],
  },
  {
    key: "interact_pro",
    name: "Professional",
    prices: [
      { key: "interact_pro_monthly", schedule: "monthly" },
      { key: "interact_pro_annual", schedule: "annual", needsFeatureSwitch: true },
    ],
    features: [
      { name: "5 GB Cloud Storage" },
      { name: "Unlimited Modules" },
      { name: "Unlimited Publishing" },
      { name: "Save Templates" },
      { name: "Ticket Support" },
    ],
  },
  // The UI currently supports displaying up to 3 plans.
  // {
  //   key: "interact_plus",
  //   name: "Professional Plus",
  //   priceKey: "interact_plus_monthly",
  //   features: [
  //     { name: "For Professional Learning Designers" },
  //     { name: "Unlimited Modules" },
  //     { name: "Feature 7" },
  //     { name: "Feature 8" },
  //   ],
  // },
];

export function getPlan(key: string | null): PlanMeta | undefined {
  return plansMeta.find((plan) => plan.key === key);
}

export function getPlanName(planKey: string | null): string {
  return getPlan(planKey)?.name ?? unknownPlanName;
}

export const unknownPlanName = "Unknown";
